import React from 'react';
import { Dimensions, StyleSheet, View } from 'react-native';
import { AnimatedView, seconds } from '../../utils/animations';

const SCREEN_HEIGHT = Dimensions.get('screen').height * 1.6;

type OverlayProps = {
    delay?: number,
}

export function Overlay(props: OverlayProps) {
    return (
        <AnimatedView
            fromTranslateX={-SCREEN_HEIGHT}
            toTranslateX={SCREEN_HEIGHT}
            fromRotateZ="-30deg"
            toRotateZ="-30deg"
            duration={seconds(1.5)}
            style={styles.container}
            delay={props.delay}
        >
            <View style={styles.firstLine} />
            <View style={styles.secondLine} />
        </AnimatedView>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        height: '160%',
        width: '100%',
        position: 'absolute',
        zIndex: 100,
        top: '-30%',
    },
    firstLine: {
        width: '50%',
        height: '100%',
        marginRight: 40,
        backgroundColor: '#F35E2E',
    },
    secondLine: {
        width: '15%',
        height: '100%',
        backgroundColor: '#FCAF41F4',
    },
});
